export var max = Math.max;
export var min = Math.min;
export var round = Math.round;


//////////////////
// WEBPACK FOOTER
// /Users/jordan/www/sites/chryso/wwwroot/wp-content/themes/chryso-v2/node_modules/@popperjs/core/lib/utils/math.js
// module id = 22
// module chunks = 0